<template>
  <router-view></router-view>
</template>

<script>
import $ from "jquery";

export default {
  name: "BaseShowCase",
  mounted() {
    $(".navbar-area").addClass("sticky");
    $(".navbar .navbar-brand img").attr("src", "/images/logo-2.webp");
    $("#home").remove();
    let nav = document.getElementById("nav");
    if (nav) {
      for (let el of nav.children) {
        if (el.id === "showcase") {
          el.classList.add("active");
        } else el.classList.remove("active");
      }
    }
  },
  beforeDestroy() {
    $(".navbar-area").removeClass("sticky");
    $(".navbar .navbar-brand img").attr("src", "images/logo.webp");
  },
};
</script>

<style lang="scss">
@import "src/styles/player";
@import "https://cdn.plyr.io/3.4.7/plyr.css";
.container-showcase {
  margin-top: 100px !important;
  padding: 30px 30px;
  margin-bottom: 200px !important;
}
video {
  width: 100%;
  height: auto !important;
}
.title-demo {
  color: rgba(0, 0, 0, 0.87);
  margin-bottom: 35px;
  margin-left: 20px;
  span {
    font-size: 13px;
  }
}
@media (max-width: 991px) {
  .container-showcase {
    display: flex;
    flex-flow: column;
  }
  .title-demo {
    margin-bottom: 50px;
    order: 1 !important;
  }
  .player {
    order: 2 !important;
  }
}
</style>
